import React from 'react';
import { faRunning, faWind, faOm } from '@fortawesome/free-solid-svg-icons';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/Button';
import ProgramCard from '../components/ProgramCard';

const HomePage = () => {
  return (
    <div className="font-sans">
      <Header activePage="home" />
      
      {/* Hero Section */}
      <section className="pt-24 relative">
        <div className="bg-gradient-to-r from-indigo-900/80 to-purple-900/80 absolute inset-0 z-10"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center" 
          style={{backgroundImage: "url('https://images.unsplash.com/photo-1545389336-cf090694435e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1964&q=80')"}}
        ></div>
        
        <div className="container mx-auto px-4 py-20 md:py-32 relative z-20">
          <div className="flex flex-col md:flex-row">
            {/* Left Content */}
            <div className="md:w-1/2 text-white mb-10 md:mb-0">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-shadow">Transformasi Diri Melalui</h2>
              <h2 className="text-4xl md:text-5xl font-bold mb-8 text-yellow-400 text-shadow">Cosmic Link</h2>
              <p className="text-lg mb-8 max-w-lg">
                Bergabunglah dengan ribuan peserta yang telah merasakan manfaat luar biasa dari program pelatihan holistik kami. Senam, meditasi, dan pengembangan spiritual dalam satu tempat.
              </p>
              <div className="flex flex-wrap gap-4">
                <Button href="#" variant="secondary">Mulai Perjalanan</Button>
                <Button href="#" variant="outline">Pelajari Lebih Lanjut</Button>
              </div>
              
              {/* Stats */}
              <div className="flex flex-wrap mt-12 gap-8 md:gap-16">
                <div className="text-center">
                  <p className="text-3xl font-bold text-white">10K+</p>
                  <p className="text-sm text-gray-200">Peserta Aktif</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold text-white">25+</p>
                  <p className="text-sm text-gray-200">Cabang</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold text-white">15+</p>
                  <p className="text-sm text-gray-200">Tahun Pengalaman</p>
                </div>
              </div>
            </div>
            
            {/* Right Content - Program Cards */}
            <div className="md:w-1/2 md:pl-10">
              <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 mb-6">
                <h3 className="text-white text-2xl font-bold mb-6">Program Unggulan</h3>
                
                {/* Program Cards */}
                <ProgramCard 
                  icon={faRunning} 
                  title="Senam RTD" 
                  description="Gerakan harmoni tubuh dan jiwa" 
                  iconBgColor="bg-yellow-500"
                  className="mb-4"
                />
                
                {/* <ProgramCard 
                  icon={faWind} 
                  title="Olah Pernafasan" 
                  description="Teknik pernapasan kosmik" 
                  iconBgColor="bg-red-500"
                  className="mb-4"
                /> */}
                
                <ProgramCard 
                  icon={faOm} 
                  title="Meditasi Kosmik" 
                  description="Koneksi dengan energi alam semesta" 
                  iconBgColor="bg-purple-500"
                />
              </div>
            </div>
          </div>
        </div>
        
        {/* Scroll Down Indicator */}
        <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 text-white z-20 animate-bounce">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Tentang LP2SDM RTD-CL</h2>
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="md:w-1/2">
              <img 
                src="https://images.unsplash.com/photo-1600618528240-fb9fc964b853?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" 
                alt="Tentang Kami" 
                className="rounded-lg shadow-lg w-full"
              />
            </div>
            <div className="md:w-1/2">
              <h3 className="text-2xl font-bold text-primary mb-4">Visi Kami</h3>
              <p className="text-gray-700 mb-6">
              Mewujudkan Lembaga Pelatihan dan Pengembangan Sumber Daya Manusia Menjadi Manusia Seutuhnya dalam Kerangka Membangun Tatanan Baru Berbasis Interdependensi.
              </p>
              <h3 className="text-2xl font-bold text-primary mb-4">Misi Kami</h3>
              <p className="text-gray-700 mb-6">
              Mewujudkan Visi Berbasis Model Keilmuan Cosmic Intelligence (Kecerdasan Kosmik) Melalui Metode RTD dan Metode Cosmic Link dalam Kiprah yang Sesuai dengan Potensi dan Kreativitas yang Dimiliki.
              </p>
              <Button to="/tentang">Pelajari Lebih Lanjut</Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
